import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { getProjectRevenueReportEndpoint } from "~/modules/project/api/projectRevenueReport/projectRevenueReportApiEndpoints.ts";
import type { ProjectRevenueReport } from "~/modules/project/api/projectRevenueReport/projectRevenueReportTypes.ts";

export function getProjectRevenueReport(projectId: string): AxiosApiResponsePromise<ProjectRevenueReport> {
	return axiosApi.get(getProjectRevenueReportEndpoint(projectId));
}
